import type { ADF } from '@atlassian/jira-rich-content/src/index.tsx';

// dummy ADF for collab service as we don't actually provide a collaborative document
export const EMPTY_DOCUMENT: ADF = {
	version: 1,
	type: 'doc',
	content: [{ type: 'paragraph', content: [] }],
};
